import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router, UrlSegment } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { map, of, switchMap, take } from 'rxjs';
import { RedirectionService } from '../services/redirection/redirection.service';
import { StoreService } from '../services/store/store.service';
import { Products } from '../interfaces/state-interface';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const redirectService = inject(RedirectionService);
  const storeService = inject(StoreService);

  return authService.isAuthenticated().pipe(
    take(1),
    map((isAuthenticated) => {
      console.log(route.url, router.url)
      if (isPublicPath(route?.url[0])) {
        if (isAuthenticated) {
          router.navigate(['/products'])
        }
        return true;
      }
      else if (!isAuthenticated) {
        router.navigate(['/login'], {queryParams: {'productType': storeService.getProduct().toLowerCase()}}); // Redirect to login page if not authenticated
        return false;
      }
      else if (isAuthenticated && !authService.isLoggedIn){
        authService.logOut();
        return false;
      }
      else if(isAuthenticated && storeService.getProduct()!=Products.GLOBAL){
        redirectService.redirectByProductName(storeService.getProduct(), {newTab: false});
        return false;
      }
      return true;
    })
  );
};

function isPublicPath(url: UrlSegment): boolean {

  if (url && url.path) {
    return ['signup', 'login', 'reset', 'verify', 'verify-mfa'].includes(url.path)
  }
  return false;
}